import "react";
import { jsx as o } from "react/jsx-runtime";
var t = (r) => /* @__PURE__ */ o("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: /* @__PURE__ */ o("path", {
    d: "m21 7.5-9 9-9-9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
export {
  t as default
};

//# sourceMappingURL=ArrowDown.js.map